// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dot {
  height: 15px;
  width: 15px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}

.trafficLightRed {
  background-color: red;
}

.trafficLightGreen {
  background-color: green;
}`, "",{"version":3,"sources":["webpack://./src/app/system-status/system-details/system-details.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AACA;EACI,uBAAA;AAEJ","sourcesContent":[".dot {\n    height: 15px;\n    width: 15px;\n    background-color: #bbb;\n    border-radius: 50%;\n    display: inline-block;\n  }\n\n.trafficLightRed{\n    background-color:red;\n}\n.trafficLightGreen{\n    background-color:green;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
